// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHero_root__4CfxX","filterBar":"PageHero_filterBar__ZbH1L"};